export const isUserTop = (value) => {
   if (!value) return false
   return value === 100 || value === '100'
}